import { render, staticRenderFns } from "./ContactInfoPanal.vue?vue&type=template&id=0bc1daa5&scoped=true&"
import script from "./ContactInfoPanal.vue?vue&type=script&lang=js&"
export * from "./ContactInfoPanal.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoPanal.vue?vue&type=style&index=0&id=0bc1daa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1daa5",
  null
  
)

export default component.exports